export function calcTotalPages(total, perPage) {
	if (!perPage || perPage <= 0) return 1;
	if (total === 0) return 1;
	return Math.ceil(total / perPage);
}

export function getPageSlice(array, page, perPage) {
	if (page < 1) return [];
	const start = (page - 1) * perPage;
	return array.slice(start, start + perPage);
}

export function renderPaginationControls(currentPage, totalPages, total, perPage) {
	if (total <= perPage) return '';

	const startItem = (currentPage - 1) * perPage + 1;
	const endItem = Math.min(currentPage * perPage, total);

	const prevDisabled = currentPage === 1 ? ' disabled' : '';
	const nextDisabled = currentPage === totalPages ? ' disabled' : '';

	const maxVisible = 5;
	let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
	let endPage = Math.min(totalPages, startPage + maxVisible - 1);
	if (endPage - startPage < maxVisible - 1) {
		startPage = Math.max(1, endPage - maxVisible + 1);
	}

	let pageButtons = '';
	if (startPage > 1) {
		pageButtons += `<button class="pagination-btn page-number" data-page="1">1</button>`;
		if (startPage > 2) pageButtons += `<span class="pagination-ellipsis">...</span>`;
	}
	for (let i = startPage; i <= endPage; i++) {
		const active = i === currentPage ? ' active' : '';
		pageButtons += `<button class="pagination-btn page-number${active}" data-page="${i}">${i}</button>`;
	}
	if (endPage < totalPages) {
		if (endPage < totalPages - 1) pageButtons += `<span class="pagination-ellipsis">...</span>`;
		pageButtons += `<button class="pagination-btn page-number" data-page="${totalPages}">${totalPages}</button>`;
	}

	return `
		<div class="pagination-controls flex items-center justify-center mt-2 mb-2">
			<span class="pagination-info text-secondary text-sm mr-2">Showing ${startItem}-${endItem} of ${total}</span>
			<button class="pagination-btn" data-page="prev"${prevDisabled}>&#8249;</button>
			<div class="page-numbers flex">${pageButtons}</div>
			<button class="pagination-btn" data-page="next"${nextDisabled}>&#8250;</button>
		</div>
	`;
}
